import "./sessao"; // primeiro: anexa a sessão assinada em toda chamada /api/
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

const el = document.getElementById("root");
if (!el) throw new Error("Elemento #root não encontrado");
createRoot(el).render(<App />);
